module.exports = __webpack_public_path__ + "media/img/pages/profile/vaudoise ger 3-a1063452bc9f58e2cf1415a74da7e277.jpg";